import { t } from 'i18next';
import { BridgeFiatRail } from 'services/merchants/types';

export const LABELS = {
  CREATE_MODAL: {
    TITLE: ['settlement.createAccountModal.title', 'Add Bank Account'],
    PAYMENT_RAIL: {
      ACH: ['settlement.createAccountModal.header.achTitle', 'ACH'],
      ACH_SAME_DAY: ['settlement.createAccountModal.header.achSameDayTitle', 'ACH Same Day'],
      ACH_PUSH: ['settlement.createAccountModal.header.achPushTitle', 'ACH Push'],
      WIRE: ['settlement.createAccountModal.header.wireTitle', 'Wire'],
      SWIFT: ['settlement.createAccountModal.header.swiftTitle', 'SWIFT'],
    },
    ACCOUNT_OWNER_TYPE: {
      INDIVIDUAL: ['settlement.createAccountModal.header.individualTitle', 'Individual'],
      BUSINESS: ['settlement.createAccountModal.header.businessTitle', 'Business'],
    },
    ACCOUNT_TYPE: {
      IBAN: ['settlement.createAccountModal.header.ibanTitle', 'IBAN'],
      OTHER: ['settlement.createAccountModal.header.otherTitle', 'Other'],
      US: ['settlement.createAccountModal.header.usTitle', 'US'],
    },
    CATEGORY: {
      CLIENT: ['settlement.createAccountModal.header.clientTitle', 'Client'],
      PARENT_COMPANY: ['settlement.createAccountModal.header.parentCompanyTitle', 'Parent Company'],
      SUBSIDIARY: ['settlement.createAccountModal.header.subsidiaryTitle', 'Subsidiary'],
      SUPPLIER: ['settlement.createAccountModal.header.supplierTitle', 'Supplier'],
    },
    CHECKING_OR_SAVINGS: {
      CHECKING: ['settlement.createAccountModal.header.checkingTitle', 'Checking'],
      SAVINGS: ['settlement.createAccountModal.header.savingsTitle', 'Savings'],
    },
    BUTTONS: {
      CREATE: ['settlement.createAccountModal.buttons.create', 'Add'],
      CANCEL: ['settlement.createAccountModal.buttons.cancel', 'Cancel'],
      CLOSE: ['settlement.createAccountModal.buttons.close', 'Close'],
    },
    SECTIONS: {
      PAYMENT_RAIL: {
        TITLE: ['settlement.createAccountModal.sections.paymentRailSection.title', 'Payment Rail'],
      },
      ACCOUNT_OWNER_TYPE: {
        TITLE: ['settlement.createAccountModal.sections.accountTypeSection.title', 'Account Owner Type'],
      },
      ACCOUNT_TYPE: {
        TITLE: ['settlement.createAccountModal.sections.accountTypeSection.title', 'Account Type'],
      },
      COUNTRY_BANK_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.countryBankSection.title', 'Country'],
      },
      CURRENCY_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.currencySection.title', 'Currency'],
      },
      BANK_NAME_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.bankNameSection.title', 'Bank Name'],
      },
      ACCOUNT_OWNER_NAME_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.accountOwnerSection.title', 'Account Owner Name'],
      },
      ACCOUNT_NUMBER_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.accountNumberSection.title', 'Account Number'],
        IBAN_TITLE: ['settlement.createAccountModal.sections.accountNumberSection.ibanTitle', 'IBAN'],
      },
      ROUTING_NUMBER_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.routingNumberSection.title', 'Routing Number'],
      },
      BIC_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.bicSection.title', 'BIC'],
      },
      BUSINESS_NAME_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.businessNameSection.title', 'Business Name'],
      },
      ADDRESS_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.addressSection.title', 'Address'],
      },
      FIRST_NAME_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.firstNameSection.title', 'First Name'],
      },
      LAST_NAME_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.lastNameSection.title', 'Last Name'],
      },
      COUNTRY_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.countrySection.title', 'Country'],
      },
      CATEGORY_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.businessOperationsSection.title', 'Business Operations'],
      },
      SHORT_BUSINESS_DESCRIPTION_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.shortBusinessDescriptionSection.title', 'Short Business Description'],
      },
      PIX_DESTINATION_TYPE_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.pixDestinationTypeSection.title', 'PIX destination type'],
      },
      PIX_DESTINATION_VALUE_SECTION: {
        PIX_KEY_TITLE: ['settlement.createAccountModal.sections.pixDestinationValueSection.pixKeyTitle', 'PIX key'],
        BR_CODE_TITLE: ['settlement.createAccountModal.sections.pixDestinationValueSection.brCodeTitle', 'BR Code'],
      },
      PIX_DOCUMENT_NUMBER_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.pixDocumentNumberSection.title', 'CPF/CNPJ (optional)'],
      },
      BREB_KEY_SECTION: {
        TITLE: ['settlement.createAccountModal.sections.brebKeySection.title', 'Bre-B key'],
      },
    },
    FORM_FIELDS: {
      OPTIONAL: ['settlement.createAccountModal.form.optional', 'Optional'],
      PLACEHOLDERS: {
        PAYMENT_RAIL: ['settlement.createAccountModal.form.paymentRail.placeholder', 'Select'],
        ACCOUNT_TYPE: ['settlement.createAccountModal.form.accountType.placeholder', 'Select'],
        BUSINESS_NAME: ['settlement.createAccountModal.form.businessName.placeholder', 'Enter Business Name'],
        BANK_NAME: ['settlement.createAccountModal.form.bankName.placeholder', 'Enter Bank Name'],
        ACCOUNT_OWNER_NAME: ['settlement.createAccountModal.form.accountOwnerName.placeholder', 'Enter Account Owner Name'],
        ACCOUNT_NUMBER: ['settlement.createAccountModal.form.accountNumber.placeholder', 'Enter Account Number'],
        ROUTING_NUMBER: ['settlement.createAccountModal.form.routingNumber.placeholder', 'Enter Routing Number'],
        BIC: ['settlement.createAccountModal.form.bic.placeholder', 'Enter BIC'],
        STREET_LINE_1: ['settlement.createAccountModal.form.streetLine1.placeholder', 'Street Line 1'],
        STREET_LINE_2: ['settlement.createAccountModal.form.streetLine2.placeholder', 'Street Line 2'],
        CITY: ['settlement.createAccountModal.form.city.placeholder', 'City'],
        STATE: ['settlement.createAccountModal.form.state.placeholder', 'State'],
        POSTAL_CODE: ['settlement.createAccountModal.form.postalCode.placeholder', 'Postal Code'],
        COUNTRY: ['settlement.createAccountModal.form.country.placeholder', 'Country'],
        FIRST_NAME: ['settlement.createAccountModal.form.firstName.placeholder', 'Enter First Name'],
        LAST_NAME: ['settlement.createAccountModal.form.lastName.placeholder', 'Enter Last Name'],
        COUNTRY_BANK: ['settlement.createAccountModal.form.countryBank.placeholder', 'Select Country'],
        CATEGORY: ['settlement.createAccountModal.form.category.placeholder', 'Select'],
        SHORT_BUSINESS_DESCRIPTION: [
          'settlement.createAccountModal.form.shortBusinessDescription.placeholder',
          'Enter the Business Description',
        ],
        PIX_KEY: ['settlement.createAccountModal.form.pixKey.placeholder', 'Enter PIX key'],
        BR_CODE: ['settlement.createAccountModal.form.brCode.placeholder', 'Enter BR Code'],
        PIX_DOCUMENT_NUMBER: ['settlement.createAccountModal.form.pixDocumentNumber.placeholder', 'Enter recipient CPF or CNPJ'],
        BREB_KEY: ['settlement.createAccountModal.form.breBKey.placeholder', 'Enter Bre-B key'],
      },
    },
    PIX_DESTINATION_TYPE: {
      PIX_KEY: ['settlement.createAccountModal.pixDestinationType.pixKey', 'PIX key'],
      BR_CODE: ['settlement.createAccountModal.pixDestinationType.brCode', 'BR Code'],
    },
    MEMO_LABEL: ['settlement.createAccountModal.memoLabel', 'Memo/Message'],
    MEMO_SUB_LABEL: [
      'settlement.createAccountModal.memoSubLabel',
      '{{paymentRail}} - Accepted length between {{minLength}} and {{maxLength}} characters.',
    ],
    MEMO_PLACEHOLDER: ['settlement.createAccountModal.memoPlaceholder', 'Enter Memo'],
    MEMO_VALIDATIN_ERROR: [
      'settlement.createAccountModal.memoValidationError',
      'Your input must be between {{min}} and {{max}} characters long. Please adjust your text accordingly.',
    ],
    OPTIONAL: ['settlement.createAccountModal.optional', 'Optional'],
  },
  ERRORS: {
    REQUIRED_FIELD: ['settlement.createAccountModal.errors.requiredField', 'This field is required.'],
    MIN_LENGTH: ['settlement.createAccountModal.errors.minLength', 'Too short'],
    MAX_LENGTH: ['settlement.createAccountModal.errors.maxLength', 'Too long'],
    INVALID_CPF_CNPJ: ['settlement.createAccountModal.errors.invalidCpfCnpj', 'Enter a valid CPF (11 digits) or CNPJ (14 digits).'],
    UNABLE_TO_GET_TITAN_DATA: ['settlement.createAccountModal.errors.unableToGetTitanData', 'Unable to get Titan data'],
    NO_BANK_ACCOUNTS: ['settlement.createAccountModal.errors.noBankAccounts', 'No bank accounts found'],
  },
  ACTIONS: {
    BACK: ['settlement.createAccountModal.actions.back', 'Back'],
    ADD: ['settlement.createAccountModal.actions.add', 'Add'],
    CANCEL: ['settlement.createAccountModal.actions.cancel', 'Cancel'],
  },
};

export const FORM_FIELDS = {
  BUSINESS_NAME: 'businessName',
  BANK_NAME: 'bankName',
  ACCOUNT_NUMBER: 'accountNumber',
  ROUTING_NUMBER: 'routingNumber',
  BIC: 'bic',
  ACCOUNT_OWNER_NAME: 'accountOwnerName',
  MEMO: 'memo',
  STREET_LINE_1: 'streetLine1',
  STREET_LINE_2: 'streetLine2',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  SHORT_BUSINESS_DESCRIPTION: 'shortBusinessDescription',
} as const;

export type FormFieldKey = (typeof FORM_FIELDS)[keyof typeof FORM_FIELDS];

export const OPTIONAL_BOTH: FormFieldKey[] = [FORM_FIELDS.STREET_LINE_2, FORM_FIELDS.STATE, FORM_FIELDS.MEMO];

export const OPTIONAL_INDIVIDUAL: FormFieldKey[] = [FORM_FIELDS.BUSINESS_NAME];

export const OPTIONAL_BUSINESS: FormFieldKey[] = [FORM_FIELDS.FIRST_NAME, FORM_FIELDS.LAST_NAME];

export const OPTIONAL_ACH_OR_WIRE: FormFieldKey[] = [FORM_FIELDS.BIC, FORM_FIELDS.SHORT_BUSINESS_DESCRIPTION];

const OPTIONAL_SWIFT: FormFieldKey[] = [FORM_FIELDS.ROUTING_NUMBER];

export const KEYS = {
  UNASSOCIATED_ERROR: 'unassociatedError',
  DEFAULT_COUNTRY_CODE: 'USA',
  ROUTING_NUMBER_MAX_LENGTH: 9,
  FORM_FIELDS,
  OPTIONAL_BOTH,
  OPTIONAL_INDIVIDUAL,
  OPTIONAL_BUSINESS,
  OPTIONAL_ACH_OR_WIRE,
  OPTIONAL_SWIFT,
};

export const paymentRailOptions = [
  {
    key: BridgeFiatRail.ACH,
    label: t(LABELS.CREATE_MODAL.PAYMENT_RAIL.ACH),
  },
  {
    key: BridgeFiatRail.ACH,
    label: t(LABELS.CREATE_MODAL.PAYMENT_RAIL.ACH_SAME_DAY),
  },
  {
    key: BridgeFiatRail.WIRE,
    label: t(LABELS.CREATE_MODAL.PAYMENT_RAIL.WIRE),
  },
  {
    key: BridgeFiatRail.SWIFT,
    label: t(LABELS.CREATE_MODAL.PAYMENT_RAIL.SWIFT),
  },
];
